import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from '@/lib/i18n'
import { DsuQuotaDetail } from '../../../-components/dsu-quota-detail'

export const Route = createFileRoute(
	'/(private)/bandi/$residenceId/quota-dsu/'
)({
	// The page names the students who hold a seat and logs the access: only opening it runs the read.
	preload: false,
	component: DsuQuotaPage,
	staticData: {
		breadcrumb: 'admin-dsu-quota:page_title'
	}
})

/** The DSU quota of a residence for the general admin who follows the calls: the same page as the manager's. */
function DsuQuotaPage() {
	const { t } = useTranslation()
	const { residenceId } = Route.useParams()
	return (
		<main className='mx-auto flex w-full max-w-5xl flex-col gap-6 p-4 md:p-6'>
			<header className='flex flex-col gap-3'>
				<Link
					className='text-muted-foreground text-sm hover:underline'
					to='/bandi'
				>
					{t('admin-dsu-quota:back')}
				</Link>
				<h1 className='font-semibold text-xl'>
					{t('admin-dsu-quota:page_title')}
				</h1>
				<p className='text-muted-foreground text-sm'>
					{t('admin-dsu-quota:intro')}
				</p>
			</header>
			<DsuQuotaDetail reader='admin' residenceId={residenceId} />
		</main>
	)
}
